import {
  AccordionDetails,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Stack
} from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVChecklistSourceDocumentation } from 'src/types/SIVChecklist';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  ISIVChecklistMandatory,
  ISIVChecklistModifiedKeys,
  ISIVChecklistModifiedKeysOfKeys,
  ISourceDocumentationMandatory,
  MandatoryData
} from './useSivChecklist';
import { setIsSaveButtonDisable } from 'src/store/sivCheckList';

export interface ISourceDocumentation {
  getSivChecklistData: (key: ISIVChecklistModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  updateSourceDocumentation: (data: ISIVChecklistSourceDocumentation) => void;
  sourceDocumentationData: ISIVChecklistSourceDocumentation;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVChecklistModifiedKeys, key: ISIVChecklistModifiedKeysOfKeys, val: boolean) => void;
  updateSIVChecklistMandatoryData: (key: keyof ISIVChecklistMandatory, value: MandatoryData) => void;
  mandatory: ISourceDocumentationMandatory;
  validatesourceDocumentation: any;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const SourceDocumentation: React.FunctionComponent<ISourceDocumentation> = ({
  getSivChecklistData,
  saveDisable,
  sourceDocumentationData,
  updateSourceDocumentation,
  isUpdate,
  isChange,
  setIsChange,
  mandatory,
  updateSIVChecklistMandatoryData,
  validatesourceDocumentation,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  // const [sourceDocumentationData, setSourceDocumentationData] = useState<any>({
  //   siv_checklist_source_doc_review: sivChecklistData.siv_checklist_source_doc_review,
  //   siv_checklist_source_doc_review_comm: sivChecklistData.siv_checklist_source_doc_review_comm || ''
  // });
  //const [isChange, setIsChange] = useState(false);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const user = useUser();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg } = useFieldTranslation();
  //const [isUpdate, setIsUpdate] = useState(sivChecklistData.study_id ? true : false);
  // const [validate, setValidate] = useState({
  //   siv_checklist_source_doc_review: false
  // } as any);

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const saveButtonDisable: any = useAppSelector(state => state.sivCheckList.disableSaveButtonProps);
  const isDisable = checkPermission('update_siv_checklist');
  const handleSourceDocumentationData = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;

    dispatchApp(clearMessage());
    if (e.target.type === 'radio' && value === 'Y') {
      updateSourceDocumentation({ ...sourceDocumentationData, [e.target.name]: value, [`${e.target.name}_comm`]: '' });
      //setValidate({ ...validate, [e.target.name]: false });
      updateSIVChecklistMandatoryData('sourceDocumentation', { ...mandatory, [e.target.name]: false });
    } else {
      updateSourceDocumentation({ ...sourceDocumentationData, [e.target.name]: value });
    }
    const validateKey = `${e.target.name.replace('_comm', '')}`;
    if (e.target.name?.indexOf('_comm') !== -1) {
      if (!(value && value !== null && value !== '')) {
        //setValidate({ ...validate, [validateKey]: true });
        updateSIVChecklistMandatoryData('sourceDocumentation', { ...mandatory, [validateKey]: true });
      } else {
        //setValidate({ ...validate, [validateKey]: false });
        updateSIVChecklistMandatoryData('sourceDocumentation', { ...mandatory, [validateKey]: false });
      }
    }
    // dispatch(setIsSaveButtonDisable(false))
    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, sourceDocumentation: false }));
    setConfirmExitValue(dispatch, true);
    //setIsChange(true);
    //setIsChanged(true);
  };
  const selectedRowData: any = useAppSelector(state => state.sivCheckList.selectedRowData);

  const updateSourceDocumentationData = async () => {
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        updated_by: user.user,
        monitoring_visit_id: selectedRowData.id,
        siv_checklist: { step_two: { source_documentation: sourceDocumentationData } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (sourceDocumentationData.siv_checklist_source_doc_review !== null) {
            await sendRequest('update_sivChecklist_data', options);
            if (isPublished) {
              SignatureBreaking();
            }
            getSivChecklistData('sourceDocumentation', false);
            setConfirmExitValue(dispatch, false);
            // setIsChange(false);
            // setIsChanged(false);
            setIsChange('Step2', 'sourceDocumentation', false);
            // store.dispatch(setSnackbarMessage('Source Documentation data is successfully saved', 'success'));
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (sourceDocumentationData.siv_checklist_source_doc_review !== null) {
            await sendRequest('create_sivChecklist_data', options);
            getSivChecklistData('sourceDocumentation', true);
            // setIsUpdate(true);
            // setIsChange(false);
            // setIsChanged(false);
            setIsChange('Step2', 'sourceDocumentation', false);
            setConfirmExitValue(dispatch, false);
            // store.dispatch(setSnackbarMessage('Source Documentation data is successfully saved', 'success'));
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else if (!isChange && sourceDocumentationData.siv_checklist_source_doc_review === null) {
        // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      } else if (validatesourceDocumentation) {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      } else {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, sourceDocumentation: true }));
    } catch (e) {
      // store.dispatch(setSnackbarMessage('Mandatory information is missing. Information cannot be saved', 'error'));
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  return (
    <>
      <AccordionDetails className="sq-checklist-tab protocol-compliance">
        <Grid container className="checklist-radio-actions">
          <Grid md={12}>
            <Grid container>
              <Grid md={9}>
                Review of source documents and types <Link underline="always">(if not in FICS)</Link>{' '}
                <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="siv_checklist_source_doc_review"
                    value={sourceDocumentationData.siv_checklist_source_doc_review}
                    onChange={handleSourceDocumentationData}
                  >
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="Y"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      disabled={!isDisable || saveDisable || !checkedInStartDate}
                      value="N"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        <Grid md={12} display="flex" justifyContent="flex-end">
          <Stack spacing={2} direction="row">
            {isDisable ? (
              <Button
                onClick={updateSourceDocumentationData}
                variant="text"
                disabled={saveButtonDisable.sourceDocumentation || !checkedInStartDate}
              >
                SAVE
              </Button>
            ) : (
              ''
            )}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default SourceDocumentation;
